import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=caddfef6&"
import script from "./Emails.vue?vue&type=script&lang=ts&"
export * from "./Emails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports